import { matchPath } from 'react-router';
export const routes = {
    productDetailPage: '/painter/products/details/:asin',
    previewOrderPage: '/checkout/preview',
    paymentSelectionPage: '/checkout/payment-selection',
    thankYouPage: '/checkout/confirm',
    creatorStorefrontPage: '/painter/content/:aci',
    linkCampaignPage: '/painter/products/linkcampaign',
    storefrontPage: '/painter/products/store/:id',
    paymentFailedPage: '/checkout/payment-failed',
};
/**
 * Allowlist of route prefixes supported in Painter 2.0
 * Routes not starting with these prefixes will redirect to legacy Painter
 * TODO: Remove this allowlist once all pages are supported in 2.0
 */
export const SUPPORTED_ROUTE_PREFIXES = [
    routes.previewOrderPage,
    routes.paymentSelectionPage,
    routes.thankYouPage,
    routes.productDetailPage,
    routes.creatorStorefrontPage,
    routes.linkCampaignPage,
    routes.paymentFailedPage,
];
// Check if the current route is supported in Painter 2.0
export const isRouteSupported = (pathname) => {
    return SUPPORTED_ROUTE_PREFIXES.some((prefix) => matchPath(prefix, pathname));
};
/**
 * Returns the route data for a given pathname
 * @param pathname
 * @returns route data and bundle id
 */
export const getRouteData = (pathname) => {
    const route = {
        isPDP: !!matchPath(routes.productDetailPage, pathname),
        isPOP: !!matchPath(routes.previewOrderPage, pathname),
        isPSP: !!matchPath(routes.paymentSelectionPage, pathname),
        isTYP: !!matchPath(routes.thankYouPage, pathname),
        isCSF: !!matchPath(routes.creatorStorefrontPage, pathname),
        isLCP: !!matchPath(routes.linkCampaignPage, pathname),
        isSFP: !!matchPath(routes.storefrontPage, pathname),
    };
    let bundleId = '';
    if (route.isPDP) {
        bundleId = 'pages.productDetails';
    }
    else if (route.isPOP) {
        bundleId = 'pages.previewOrderPage';
    }
    else if (route.isPSP) {
        bundleId = 'pages.paymentSelectionPage';
    }
    else if (route.isTYP) {
        bundleId = 'pages.thankYouPage';
    }
    else if (route.isCSF || route.isSFP) {
        bundleId = 'pages.storefrontPage';
    }
    else if (route.isLCP) {
        bundleId = 'pages.linkCampaign';
    }
    return { route, bundleId };
};
